
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Dhamal Dandiya </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm dhamaal-dandiya section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Dhamal<span > Dandiya</span></h2>
        </div>
        <div class="row mt-5">
            <div class="col-md-6">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-1.webp"
                        alt="GHRSCF">
                </div>
            </div>
            <div class="col-lg-6">
                <div class=" text-justify">
                    <div class="widget_title inner-title">
                        <h4>Celebrating Dhamaal Dandiya</h4>
                    </div>
                    <div class="fide-chess-text">
                        <p>We, at The Raisoni Group of Institutions have the most accomplished, outstanding and
                            student-centric school of thought as its foundation stone. There is that amalgamation of
                            theory
                            with practical application, ethics and moral values, academics and co-curricular which
                            caters to
                            the all round development of our students. This is the rationale all round the year
                            activities,
                            conferences, seminars, industry visit, events, inter-collegiate are held to benefit them.
                        </p>
                    </div>
                    <p>
                        Amidst the plethora of events, there is that one event which makes sure to be that perfect
                        mingling of
                        values, ethics, jubilance and devotion. Add to it just the apt ingredient of celebrity visit and
                        you get- Dhamaal Dandiya!
                    </p>
                </div>
            </div>
            <div class="col-lg-12">
                <p>The word Dhamaal and Dandiya quite perfectly complements each other. The most wonderful aspect is
                    that it reflects devotion well merged with enthusiasm and love for the Goddess. And, when ethics are
                    associated the onset cannot be better than through devotion.</p>
            </div>
        </div>
        <div class="widget_title inner-title">
            <h4>What is Dhamaal Dandiya?
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li>A 9 day festival which starts with the onset of Navratri (the most pious 9 days of the Goddess)</li>
            <li>The devotion is accompanied everyday by the Garba/Dandiya dance</li>
            <li>It is one of the grandeur events of the ye</li>
        </ul>
        <div class="widget_title inner-title">
            <h4>What does it include?
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li><b>Dance troupe-</b> setting the ambiance full of color, vibrancy and music is the inner circle. It
                comprises of the students of the Raisoni group of college performing the most beautiful steps,
                choreographed by none other than the college’s own choreographer</li>
            <li><b>Students-</b> dancing with full enthusiasm to the beats of the most amazing dance numbers and live
                band</li>
            <li><b>Awards-</b> a plethora of awards/prizes to be won daily! This includes the best dancers- boys and
                girls, and the best dressed prizes. Not to obliterate the on spot prizes!</li>
            <li><b>Don up and show-</b> that 9 day opportunity to dress like a star</li>
            <li><b>Celebrity attendance-</b> marks the participation of a TV celebrity to grace the occasion</li>
        </ul>
        <div class="widget_title inner-title">
            <h4>For the students
            </h4>
        </div>
        <div class="fide-chess-text">
            <p>Well definitely, the college life is and will always be the most pertinent part of your journey of life.
                While it continues to be indispensable for your safe and successful future, the same lies true to the
                jubilance you can be on the receiving end of in here. It is for this reason the Dhamaal Dandiya
                continues
                to be the most happening and amazing event of the year.</p>
        </div>
        <div class="widget_title inner-title">
            <h4>You get to
            </h4>
        </div>
        <ul class="list-style list-style1">
            <li>Meet new students</li>
            <li>Showcase your talent</li>
            <li>Dress yourself in the most amazing manner</li>
            <li>Take pleasure in a live band and foot tapping music</li>
            <li>Enjoy in the safe premises of the college</li>
        </ul>
        <p>The Raisoni Group of Institutions has made sure to inculcate in its students the virtue of moral values,
            ethics and cultural beliefs with each and every event. The basis behind this has been to ensure their
            complete development.</p>
        <p>A human should not aim at being a successful machine. The objective should instead be that apt amalgamation
            of values, morals and jubilance in every moment and every part of their life.</p>


        <div class="row">
            <div class="col-md-8">
                <div class="widget_title inner-title">
                    <h4>PHOTOS</h4>
                </div>
            </div>
            <div class="col-md-4 text-end">
                <a href="dhamaal-dandiya-yearly" class="cmn-button"><span>
                        View More</span>
                </a>
            </div>
        </div>

        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/cultural-events/dd2018/dd2018-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>


            </ul>
        </div>


    </div>
</section>
